import React, { useState } from "react";
import {
  Box,
  FormButtonStyled,
  LabelStyled,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ValidationErrorText from "../../../../components/common/inputFields/ValidationErrorText";
import { emailRegex, phoneRegex } from "../../../../utils";
import PhoneInputField from "../../../../components/common/inputFields/PhoneInput";

const SignupStep1 = ({
  handleSteps,
  register,
  control,
  errors,
  setValue,
  watch,
  planInfo,
  loading,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(1);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSelectedOption(parseInt(value));
    setValue(name, parseInt(value));
  };

  return (
    <Step1Wrapper>
      <Box>
        <Box>
          <ValidatedInput
            name="name"
            label={"name"}
            type="input"
            fieldType="text"
            placeholder={"namePlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
            }}
          />
        </Box>
        <Box className="mb-3">
          <Box>
            <LabelStyled
              size="16px"
              weight="bold"
              color="var(--text)"
              className="mb-1"
            >
              {t("type")}
            </LabelStyled>
          </Box>
          <Box className="d-flex gap-3">
            <CustomRadioButton
              name="type"
              label={t("organization")}
              value={1}
              checked={selectedOption === 1}
              register={register}
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />

            <CustomRadioButton
              name="type"
              label={t("individual")}
              value={2}
              checked={selectedOption === 2}
              register={register}
              validationRules={{
                required: true,
                onChange: handleChange,
              }}
            />
          </Box>
          {errors?.type?.type === "required" && (
            <ValidationErrorText
              text={
                t(errors?.type?.message) || `${t("type")} ${t("isRequired")}.`
              }
            />
          )}
        </Box>
        <Box>
          {selectedOption === 1 && (
            <ValidatedInput
              name="organization_name"
              label={"organization_name"}
              type="input"
              fieldType="text"
              placeholder={"orgNamePlaceholder"}
              className={"mb-3 combined flex-wrap p-0"}
              bg="var(--white)"
              register={register}
              errors={errors}
              validationRules={{
                required: true,
              }}
            />
          )}
        </Box>
        <Box>
          <ValidatedInput
            name="email"
            label={"email"}
            type="input"
            fieldType="email"
            placeholder={"emailPlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
              inline: true,
              pattern: {
                value: emailRegex,
                message: "invalidEmail",
              },
            }}
          />
        </Box>
        <Box>
          <PhoneInputField
            name="phone"
            label={"phone"}
            placeholder={"phonePlaceholder"}
            register={register}
            control={control}
            errors={errors}
            validationRules={{
              required: true,
            }}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
          />
        </Box>
        <Box>
          <ValidatedInput
            name="password"
            label={"password"}
            type="input"
            fieldType="password"
            placeholder={"passwordPlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: true,
              inline: true,
              minLength: {
                value: 8,
                message: "lengthGreaterThen",
              },
            }}
          />
        </Box>
        <Box>
          <ValidatedInput
            name="confirm_password"
            label={"confirm_password"}
            type="input"
            fieldType="password"
            placeholder={"confirmPasswordPlaceholder"}
            className={"mb-3 combined flex-wrap p-0"}
            bg="var(--white)"
            register={register}
            errors={errors}
            validationRules={{
              required: {
                value: true,
                message: "fieldRequired",
              },
              inline: true,
              //   minLength: {
              //     value: 8,
              //     message: "lengthGreaterThen",
              //   },
              validate: (value) =>
                value === watch("password") || "password_do_not_match",
            }}
          />
        </Box>
      </Box>
      <FormButtonStyled
        label={t("sign_up")}
        color="var(--white)"
        bg="var(--themeColor)"
        className="w-100"
        clName="w-100 my-4"
        type="submit"
        isLoading={loading}
      />
      {/* {parseInt(planInfo.plan_id) === 1 ? (
        <FormButtonStyled
          label={t("sign_up")}
          color="var(--white)"
          bg="var(--themeColor)"
          className="w-100"
          clName="w-100 my-4"
          type="submit"
          isLoading={loading}
        />
      ) : (
        <FormButtonStyled
          label={t("next")}
          color="var(--white)"
          bg="var(--themeColor)"
          className="w-100"
          clName="w-100 my-4"
          type="button"
          onClick={handleSteps}
        />
      )} */}
      <Box className="d-flex justify-content-center justify-content-sm-end">
        <Box>
          <TextStyled color="var(--text2  )" size="16px" weight="500">
            {t("already_have_account")}
            &emsp;
            <SpanStyled
              className="cursor-pointer"
              color="var(--themeColor)"
              size="16px"
              weight="700"
              onClick={() => navigate("/login")}
            >
              {t("sign_in")}
            </SpanStyled>
          </TextStyled>
        </Box>
      </Box>
    </Step1Wrapper>
  );
};

export default SignupStep1;

const Step1Wrapper = styled.div``;
